export const ComparationStructures = {
    donut: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    pie: {
        category: "combinations",
        chart: {
            reflow: true,
            renderTo: {}
        },
        legend: {
            enable: true
        },
        series: [],
        yAxis: [
            {
                labels: {
                    enabled: true,
                    formatter: "currency"
                },
                title: {
                    text: ""
                },
                plotLines: [
                    {
                        width: 1,
                        value: 0,
                        zIndex: 6
                    }
                ]
            }
        ],
        plotOptions: {
            series: {
                borderWidth: 0
            },
            column: {}
        }
    },
    columnrange: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    waterfall: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    columncomparation: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    gauge: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    }
};

export const AnalysisPlusStructures = {
    donut: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    pie: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    columnrange: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    waterfall: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    columncomparation: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    gauge: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    area: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    line: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    },
    column: {
        category: "column",
        plotOptions: {
            series: {
                borderWidth: 0,
                marker: { enabled: true, radius: 4 },
                animation: {
                    duration: 1000
                },
                fillOpacity: 0.66,
                states: {
                    hover: {
                        enabled: true,
                        fillOpacity: 1
                    }
                }
            }
        },
        series: [],
        chart: {
            reflow: true,
            type: "column"
        },
        legend: {
            enabled: true
        },
        yAxis: {
            reversed: false,
            title: {
                enabled: false
            },
            plotLines: [
                {
                    width: 1,
                    value: 0,
                    zIndex: 6
                }
            ],
            labels: {
                enabled: true
            }
        }
    }
};
